import React from 'react';
import { Card, Tag, Typography, Space, Button } from 'antd';
import { EyeOutlined, FilePdfOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { Text } = Typography;

// Contrato de GET /api/professor/pagamentos (Fase 14D): id,
// mes_referencia, status, pago, data_pagamento, total_horas, valor_base,
// valor_ajustes, valor_final. Sem id_equipe/dado bancário/dado de outro
// professor.

const STATUS_INFO = {
  RASCUNHO: { color: 'orange', text: 'Rascunho' },
  FECHADA: { color: 'blue', text: 'Fechada' },
  PAGA: { color: 'green', text: 'Paga' },
};

const formatarValor = (valor) => `R$ ${Number(valor || 0).toFixed(2)}`;
const formatarCompetencia = (mesReferencia) => dayjs(`${mesReferencia}-01`).format('MMMM/YYYY');

const PagamentoProfessorCard = ({ pagamento, onVerDetalhes, onBaixarRecibo }) => {
  const statusInfo = STATUS_INFO[pagamento.status] || { color: 'default', text: pagamento.status };

  return (
    <Card className="portal-professor__card" data-testid="pagamento-card">
      <Space direction="vertical" size={2} style={{ width: '100%' }}>
        <Text strong style={{ fontSize: 16, lineHeight: 1.3, textTransform: 'capitalize' }}>
          {formatarCompetencia(pagamento.mes_referencia)}
        </Text>
        <Tag color={statusInfo.color} style={{ width: 'fit-content' }}>
          {statusInfo.text}
        </Tag>
        <Text style={{ fontSize: 18, fontWeight: 600, color: '#1677ff' }}>
          {formatarValor(pagamento.valor_final)}
        </Text>
        {pagamento.total_horas != null && (
          <Text type="secondary" style={{ fontSize: 13 }}>
            {Number(pagamento.total_horas).toFixed(2)}h de aula
          </Text>
        )}
        {pagamento.data_pagamento && (
          <Text type="secondary" style={{ fontSize: 13 }}>
            Pago em {dayjs(pagamento.data_pagamento).format('DD/MM/YYYY')}
          </Text>
        )}

        <Space style={{ marginTop: 8 }} wrap>
          <Button icon={<EyeOutlined />} size="small" onClick={() => onVerDetalhes(pagamento)}>
            Ver detalhes
          </Button>
          <Button icon={<FilePdfOutlined />} size="small" onClick={() => onBaixarRecibo(pagamento)}>
            Baixar recibo
          </Button>
        </Space>
      </Space>
    </Card>
  );
};

export default PagamentoProfessorCard;
